'use strict';
import * as $j_app$002edata$002etypes$005fdrug$0024package$0024$002dDrug$002dRequest$002dId$0024 from "./app.data.types_drug$package$-Drug-Request-Id$.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$22() {
}
export { $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$22 as $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$22 };
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$22.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$22.prototype.constructor = $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$22;
/** @constructor */
function $h_Lapp_api_DrugRequestsAcceptedListItem$$anon$22() {
}
export { $h_Lapp_api_DrugRequestsAcceptedListItem$$anon$22 as $h_Lapp_api_DrugRequestsAcceptedListItem$$anon$22 };
$h_Lapp_api_DrugRequestsAcceptedListItem$$anon$22.prototype = $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$22.prototype;
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$22.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$22.prototype.apply__O = (function() {
  return $j_app$002edata$002etypes$005fdrug$0024package$0024$002dDrug$002dRequest$002dId$0024.$m_Lapp_data_types\uff3fdrug$package$DrugRequestId$().schema__Lsttp_tapir_Schema();
});
var $d_Lapp_api_DrugRequestsAcceptedListItem$$anon$22 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_DrugRequestsAcceptedListItem$$anon$22, "app.api.DrugRequestsAcceptedListItem$$anon$22", ({
  Lapp_api_DrugRequestsAcceptedListItem$$anon$22: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_api_DrugRequestsAcceptedListItem$$anon$22 as $d_Lapp_api_DrugRequestsAcceptedListItem$$anon$22 };
//# sourceMappingURL=app.api.-Drug-Requests-Accepted-List-Item$$anon$22.js.map
